import { GETCATEGORY_SUCCESS, GETCATEGORY_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getCategoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETCATEGORY_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETCATEGORY_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getCategoryReducer;
